import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../../components/layout";
import {
  Breadcrumbs,
  Button,
  Modal,
  Select,
} from "../../../../../components/core";
import PickupFeesTable from "../user-fees/pick-up-fees-table";
import { useDispatch, useSelector } from "react-redux";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import {
  handelCancelChagesReducer,
  handleAddDataItemReducer,
  handleChangeLockerTypeAndUserTypeReducer,
  handleEditAddedDataReducer,
  handleShipoutAddDataItemReducer,
  handleShipoutEditAddedDataReducer,
  setLockerTypeList,
} from "../../../../../features/locker-fees/add-user-fees/add-user-fees-slice";
import {
  ADD_USER_PICKUP_FEES,
  ADD_USER_SHIPOUT_FEES,
  LOCKER_TYPES,
  LOCKER_USER_TYPE,
} from "../../../../../constants/graphql/locker-queries";
import ShipoutFeesTable from "../user-fees/rejected-shipout-fees";
import { useNavigate, useParams } from "react-router-dom";
import { Strings } from "../../../../../constants/strings";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
function getUniqueObjectsFromArray1(array1, array2) {
  // Create a map to count id occurrences in array2
  const idCountMap = {};
  array2.forEach((obj) => {
    const userTypeId = obj.userTypeId;
    idCountMap[userTypeId] = (idCountMap[userTypeId] || 0) + 1;
  });

  // Filter array1 to include only objects with unique id values
  const uniqueObjects = array1.filter((obj) => {
    const userTypeId = obj.userTypeId;
    return idCountMap[userTypeId] === 1; // Include if id occurs exactly once in array2
  });

  return uniqueObjects;
}
function validateArrayOfObjects(arr) {
  let atLeastOneEmpty = false;
  let atLeastOneNotEmpty = false;

  for (const obj of arr) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        if (value !== "") {
          atLeastOneNotEmpty = true;
        } else {
          atLeastOneEmpty = true;
        }
      }
    }
  }

  // Check if one condition is true and the other is false
  return (
    (atLeastOneNotEmpty && !atLeastOneEmpty) ||
    (!atLeastOneNotEmpty && atLeastOneEmpty)
  );
}
const breadcrumbItems = [
  {
    label: "Locker Fees",
    path: `/locker-fees/`,
  },
  { label: "Add User Fee", path: "#" },
];
export default function AddUserFees() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { userTypes, lockerTypeId } = useParams();
  const url = window.location.href;
  // const userTypes = JSON.parse(
  // 	decodeURIComponent(url.split("/")[url.split("/").length - 2])
  // );
  const lockerTypeId = url.split("/")[url.split("/").length - 1];

  const [lockerUserTypesList, setLockerUserTypesList] = useState([]);
  //Selectors
  //   const addDataItem = useSelector((state) => state.addUserFee.addDataItem);
  const addShipoutData = useSelector(
    (state) => state.addUserFee.addShipoutData
  );
  const [addedPickupFees, setAddedPickupFees] = React.useState([]);

  // const lockerUserTypesList = useSelector(
  // 	(state) => state.addUserFee.lockerUserTypesList
  // );

  console.log({ lockerUserTypesList });
  const lockerTypesList = useSelector(
    (state) => state.addUserFee.lockerTypesList
  );
  const lockerTypeAndUserType = useSelector(
    (state) => state.addUserFee.lockerTypeAndUserType
  );
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  //graphql
  const lockerUserTypes = useQuery(LOCKER_USER_TYPE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const lockerTypes = useQuery(LOCKER_TYPES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const [addUserPickupFee] = useMutation(ADD_USER_PICKUP_FEES);
  const [addUserShipoutFee] = useMutation(ADD_USER_SHIPOUT_FEES);
  // Local states
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [confirmValidation, setConfirmValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [changesMade, setChangesMade] = useState(false);
  const handleAddDataItem = () => {
    let tempArr = [...addedPickupFees];

    // dispatch(
    //   handleAddDataItemReducer({
    //     operatorId: localStorage.getItem("user")
    //       ? JSON.parse(localStorage.getItem("user")).operator_id
    //       : "",
    //     lockerTypeId: lockerTypeId,
    //     userTypeId: lockerTypeAndUserType.userTypeId,
    //     doorSizeId: "1",
    //     initialFee: "",
    //     addInitialFreeHours: "",
    //     excessFeePerInc: "",
    //     incByHours: "",
    //     maxOverstayCharge: "",
    //   })
    // );
    tempArr.push({
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      lockerTypeId: lockerTypeId,
      userTypeId: lockerTypeAndUserType.userTypeId,
      doorSizeId: "1",
      initialFee: "",
      addInitialFreeHours: "",
      excessFeePerInc: "",
      incByHours: "",
      maxOverstayCharge: "",
    });
    setAddedPickupFees(tempArr);

    setChangesMade(true);
  };

  console.log({ lockerTypeAndUserType });
  // React.useEffect(() => {
  // 	console.log(userTypes);
  // }, [userTypes]);
  const handleShipoutAddDataItem = () => {
    dispatch(
      handleShipoutAddDataItemReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: lockerTypeId,
        userTypeId: lockerTypeAndUserType.userTypeId,
        doorSizeId: "1",
        initialReturnFee: "",
        addInitialFreeHours: "",
        excessFeePerInc: "",
        incByHours: "",
        maxOverstayCharge: "",
      })
    );
    setChangesMade(true);
  };
  const handleOnChangeLockerTypeAndUserType = (event) => {
    const { name, value } = event.target;
    dispatch(
      handleChangeLockerTypeAndUserTypeReducer({ name: name, value: value })
    );
    setChangesMade(true);
  };

  const handleEditAddedData = (event) => {
    const { name, value, id } = event.target;
    console.log({ name, value, id });
    let tempArr = [...addedPickupFees];
    tempArr[id][name] = value;
    setAddedPickupFees(tempArr);

    // dispatch(handleEditAddedDataReducer({ name: name, value: value, id: id }));
    setChangesMade(true);
  };
  const handleShipoutEditAddedData = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleShipoutEditAddedDataReducer({ name: name, value: value, id: id })
    );
    setChangesMade(true);
  };
  useEffect(() => {
    // console.log("Effect triggered:", {
    // 	pendingNavigationHere,
    // 	changesMade,
    // 	currentPath: location.pathname,
    // });
    if (pendingNavigation !== null) {
      if (changesMade) {
        // setCancelDialogOpen(true);
        console.log("open dialog");
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);
  // const handleSaveChanges = () => {
  // 	let filteredDuplicateDoorSize = [...addDataItem].filter(
  // 		(x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
  // 	);
  // 	let filteredDuplicateDoorSizeShipout = [...addShipoutData].filter(
  // 		(x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
  // 	);

  // 	if (lockerTypeAndUserType.userTypeId === "-1") {
  // 		setValidation({
  // 			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 			title: "Incomplete Search Criteria",
  // 			message: "Please select User Type.",
  // 			open: true,
  // 		});
  // 	} else if (
  // 		filteredDuplicateDoorSize.length > 0 ||
  // 		filteredDuplicateDoorSizeShipout.length > 0
  // 	) {
  // 		setValidation({
  // 			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 			title: Strings.popup_error_title_duplicate,
  // 			message: "There is duplicate door size in your entry.",
  // 			open: true,
  // 			actions: (
  // 				<div className="w-full">
  // 					<Button
  // 						onClick={() => setValidation({ open: false })}
  // 						value={"OK"}
  // 						className={"p-2 w-full"}
  // 					/>
  // 				</div>
  // 			),
  // 		});
  // 	} else {
  // 		// Declaration part
  // 		let flag = true;

  // 		// Validation Part
  // 		const pickupValidationVar = addDataItem.map((obj) => {
  // 			// Create a copy of the object without the specified field
  // 			const newObj = { ...obj };

  // 			// Delete the field from the copied object
  // 			delete newObj["doorSizeId"];
  // 			delete newObj["operatorId"];
  // 			delete newObj["lockerTypeId"];
  // 			delete newObj["userTypeId"];

  // 			return newObj;
  // 		});
  // 		const noEmptyPickup = pickupValidationVar.filter((obj) => {
  // 			// Check if at least one field is not empty
  // 			for (const key in obj) {
  // 				if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
  // 					return true; // Keep the object
  // 				}
  // 			}
  // 			return false; // Remove the object
  // 		});
  // 		const shipoutValidationVar = addShipoutData.map((obj) => {
  // 			// Create a copy of the object without the specified field
  // 			const newObj = { ...obj };

  // 			// Delete the field from the copied object
  // 			delete newObj["doorSizeId"];
  // 			delete newObj["operatorId"];
  // 			delete newObj["lockerTypeId"];
  // 			delete newObj["userTypeId"];

  // 			return newObj;
  // 		});
  // 		const noEmptyShipout = shipoutValidationVar.filter((obj) => {
  // 			// Check if at least one field is not empty
  // 			for (const key in obj) {
  // 				if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
  // 					return true; // Keep the object
  // 				}
  // 			}
  // 			return false; // Remove the object
  // 		});

  // 		// Traversing part
  // 		if (noEmptyPickup.length > 0) {
  // 			if (validateArrayOfObjects(pickupValidationVar)) {
  // 				addDataItem.forEach((element) => {
  // 					addUserPickupFee({ variables: element })
  // 						.then(() => {
  // 							navigate("/locker-fees/");
  // 						})
  // 						.catch((e) => {
  // 							flag = false;
  // 							setValidation({
  // 								icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 								title: "Server error",
  // 								message:
  // 									"There may be a duplication to the data or you have weak internet connection to proceed.",
  // 								open: true,
  // 							});
  // 						});
  // 				});
  // 			} else {
  // 				setValidation({
  // 					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 					title: "Empty fields error",
  // 					message:
  // 						"Some of your fields is/are empty. Please complete the form",
  // 					open: true,
  // 				});
  // 				flag = false;
  // 			}
  // 		}
  // 		if (noEmptyShipout.length > 0) {
  // 			if (validateArrayOfObjects(shipoutValidationVar)) {
  // 				addShipoutData.forEach((element) => {
  // 					addUserShipoutFee({ variables: element })
  // 						.then(() => {
  // 							navigate("/locker-fees/");
  // 						})
  // 						.catch((e) => {
  // 							flag = false;
  // 							setValidation({
  // 								icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 								title: "Server error",
  // 								message:
  // 									"There may be a duplication to the data or you have weak internet connection to proceed.",
  // 								open: true,
  // 							});
  // 						});
  // 				});
  // 			} else {
  // 				setValidation({
  // 					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 					title: "Empty fields error",
  // 					message:
  // 						"Some of your fields is/are empty. Please complete the form",
  // 					open: true,
  // 				});
  // 				flag = false;
  // 			}
  // 		}

  // 		// Last Validation Part
  // 		if (flag) {
  // 			if (noEmptyPickup.length === 0 && noEmptyShipout.length === 0) {
  // 				flag = false;
  // 				setValidation({
  // 					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 					title: "Locker fee error",
  // 					message: "No changes added. Cannot proceed to save.",
  // 					open: true,
  // 				});
  // 			} else {
  // 				console.log(noEmptyPickup);
  // 				console.log(noEmptyShipout);
  // 				setValidation({
  // 					icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
  // 					title: "Success",
  // 					message: "Successfuly added fee.",
  // 					open: true,
  // 				});
  // 				navigate("/locker-fees/");
  // 			}
  // 		}
  // 	}
  // };

  const handleSaveChanges = async () => {
    // Check for duplicate door sizes
    // const filteredDuplicateDoorSize = [...addDataItem].filter(
    //   (x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
    // );
    // const filteredDuplicateDoorSizeShipout = [...addShipoutData].filter(
    //   (x, i, self) => self.findIndex((y) => y.doorSizeId === x.doorSizeId) !== i
    // );

    // Initial validations
    if (lockerTypeAndUserType.userTypeId === "-1") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Search Criteria",
        message: "Please select User Type.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    // if (
    //   filteredDuplicateDoorSize.length > 0 ||
    //   filteredDuplicateDoorSizeShipout.length > 0
    // ) {
    //   setValidation({
    //     icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    //     title: Strings.popup_error_title_duplicate,
    //     message: "There is duplicate door size in your entry.",
    //     open: true,
    //     actions: (
    //       <div className="w-full">
    //         <Button
    //           onClick={() => setValidation({ open: false })}
    //           value={"OK"}
    //           className={"p-2 w-full"}
    //         />
    //       </div>
    //     ),
    //   });
    //   return;
    // }

    // Prepare and validate pickup data
    const pickupValidationVar = addedPickupFees.map(
      ({ doorSizeId, operatorId, lockerTypeId, userTypeId, ...rest }) => rest
    );
    const noEmptyPickup = pickupValidationVar.filter((obj) =>
      Object.values(obj).some(
        (value) => value !== "" && value !== null && value !== undefined
      )
    );

    // Prepare and validate shipout data
    const shipoutValidationVar = addShipoutData.map(
      ({ doorSizeId, operatorId, lockerTypeId, userTypeId, ...rest }) => rest
    );
    const noEmptyShipout = shipoutValidationVar.filter((obj) =>
      Object.values(obj).some(
        (value) => value !== "" && value !== null && value !== undefined
      )
    );

    // Check if there are any changes to save
    if (noEmptyPickup.length === 0 && noEmptyShipout.length === 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Locker fee error",
        message: "No changes added. Cannot proceed to save.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    console.log({ addedPickupFees });
    try {
      // Handle pickup fees
      if (noEmptyPickup.length > 0) {
        if (!validateArrayOfObjects(pickupValidationVar)) {
          throw new Error(
            "Some pickup fields are empty. Please complete the form."
          );
        }

        // Execute pickup mutations sequentially
        for (const element of addedPickupFees) {
          await addUserPickupFee({ variables: element });
        }
      }

      // Handle shipout fees
      if (noEmptyShipout.length > 0) {
        if (!validateArrayOfObjects(shipoutValidationVar)) {
          throw new Error(
            "Some shipout fields are empty. Please complete the form."
          );
        }

        // Execute shipout mutations sequentially
        for (const element of addShipoutData) {
          await addUserShipoutFee({ variables: element });
        }
      }

      // If we reach here, all mutations were successful
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_success_title_default,
        message: Strings.popup_success_message_add,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                // setValidation({ open: false });
                // Navigate after all mutations are complete
                navigate(
                  `/locker-fees/edit-user-fees/${lockerTypeId}/${lockerTypeAndUserType?.userTypeId}`
                );
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } catch (error) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Server error",
        message:
          "There may be a duplication to the data or you have weak internet connection to proceed.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }
  };

  const handleCancelChanges = () => {
    dispatch(handelCancelChagesReducer());
  };

  console.log({ lockerUserTypes });
  React.useEffect(() => {
    if (lockerUserTypes && lockerUserTypes.data?.lockerUserTypes?.length > 0) {
      const map = lockerUserTypes.data.lockerUserTypes
        .filter(
          (category) =>
            !(
              category.userPickupFees?.length > 0 ||
              category.userPickupFees?.length > 0
            )
        ) // removes those with userPickupFees
        .map((category) => ({
          value: category.userTypeId,
          name: category.userType,
        }));

      console.info({ map });
      setLockerUserTypesList(map);
    }
  }, [lockerUserTypes.data]);

  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempVar = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempVar.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      dispatch(setLockerTypeList(tempVar));
    }
  }, [lockerTypes.data]);
  React.useEffect(() => {
    dispatch(handelCancelChagesReducer());
  }, []);
  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"Locker Fees"}>
        <div className="left w-1/2 grid grid-cols-2 gap-x-2 gap-y-6 pr-2">
          <p className="my-auto">Locker Type:</p>
          <p className="font-bold">
            {lockerTypesList.find((x) => x.value === lockerTypeId) &&
              lockerTypesList.find((x) => x.value === lockerTypeId).name}
          </p>
          {/* <Select
            items={lockerTypesList}
            value={lockerTypeAndUserType.lockerTypeId}
            name="lockerTypeId"
            onChange={handleOnChangeLockerTypeAndUserType}
            defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
          /> */}
          <p className="my-auto">User Type:</p>
          <Select
            items={lockerUserTypesList}
            value={lockerTypeAndUserType.userTypeId}
            name="userTypeId"
            onChange={handleOnChangeLockerTypeAndUserType}
            defaultOption={{ value: "-1", name: "-- Select User Type --" }}
          />
        </div>
        <PickupFeesTable
          lockerType={
            lockerTypesList.find((x) => x.value === lockerTypeId)
              ? lockerTypesList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          userType={
            lockerUserTypesList.find(
              (x) => x.value === lockerTypeAndUserType.userTypeId
            )
              ? lockerUserTypesList.find(
                  (x) => x.value === lockerTypeAndUserType.userTypeId
                ).name
              : ""
          }
          handleAddDataItem={handleAddDataItem}
          handleModifyAddedItems={handleEditAddedData}
          addedData={addedPickupFees}
        />
        <ShipoutFeesTable
          lockerType={
            lockerTypesList.find((x) => x.value === lockerTypeId)
              ? lockerTypesList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          userType={
            lockerUserTypesList.find(
              (x) => x.value === lockerTypeAndUserType.userTypeId
            )
              ? lockerUserTypesList.find(
                  (x) => x.value === lockerTypeAndUserType.userTypeId
                ).name
              : ""
          }
          handleAddDataItem={handleShipoutAddDataItem}
          handleModifyAddedItems={handleShipoutEditAddedData}
          addedData={addShipoutData}
        />
        {changesMade && (
          <div className="grid grid-cols-2 gap-2 w-1/4">
            <Button
              value={"Cancel Changes"}
              className={"p-2"}
              onClick={() => {
                setConfirmValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                  title: "Cancel Changes",
                  message: "Are you sure you want to cancel changes?",
                  open: true,
                  event: handleCancelChanges,
                });
              }}
            />
            <Button
              value={"Save Changes"}
              className={"p-2"}
              onClick={() => {
                setConfirmValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: "Save Changes",
                  message: "Are you sure you want to save changes?",
                  open: true,
                  event: handleSaveChanges,
                });
              }}
            />
          </div>
        )}
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          // actions={
          // 	<div className="grid grid-cols-1 gap-2">
          // 		<Button
          // 			onClick={() => {
          // 				setValidation((prev) => ({
          // 					...prev,
          // 					open: false,
          // 				}));
          // 			}}
          // 			value={"OK"}
          // 			className={"p-2"}
          // 		/>
          // 	</div>
          // }
          actions={validation.actions}
        />
        <Modal
          icon={confirmValidation.icon}
          title={confirmValidation.title}
          message={confirmValidation.message}
          open={confirmValidation.open}
          actions={
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}
                value={"No"}
                className={"p-2"}
              />
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                  confirmValidation.event();
                }}
                value={"Yes"}
                className={"p-2"}
              />
            </div>
          }
        />
      </ContentContainer>
    </div>
  );
}
